export class WidgetConfigError extends Error {
  constructor(message) {
    super(message);
  }
}
